import React from 'react'
import UserContainerComponent from '../../components/usersComponents/UserContainerComponent';

function Autorizacion() {
    return (
        <UserContainerComponent>
            <div className='px-4 lg:px-8'>
                <p>Autorizacion</p>
            </div>
        </UserContainerComponent>
    );
}

export default Autorizacion;